import api from "./AxiosInstance";

const end = "/api";

export const ReceiptApi = {
  getReceiptNo: async (data) => {
    const response = await api.post(end + `/getReceiptNo`, data);
    return response.data;
  },
  addReceiptPayment: async (data) => {
    const response = await api.post(end + `/addReceiptPayment`, data);
    return response.data;
  },
  getReceiptPaymentById: async (data) => {
    const response = await api.post(end + `/getReceiptPaymentById`, data);
    return response.data;
  },
  getReceiptNoByBillNo: async (data) => {
    const response = await api.post(end + `/getReceiptNoByBillNo`, data);
    return response.data;
  },
  deleteReceiptPaymentById: async (data) => {
    const response = await api.post(end + `/deleteReceiptPaymentById`, data);
    return response.data;
  },
};
